import { createSelector } from 'reselect'
import { parseParams } from '../../legacyLib/helpers/paramsHelper'

const getUrlSearch = state => state.router.location.search

export const urlFilters = createSelector([getUrlSearch], urlSearch => parseParams(urlSearch))
